import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  CommentFragment,
  GetForumBySlugDocument,
} from "graphql/generated/generated";
import Comment from "components/comments/Comment";

interface Props {
  comments: CommentFragment[];
}

const useStyles = makeStyles({
  comments: {
    borderTop: "1px solid #ddd",
    marginTop: 50,
    paddingTop: 30,
  },
});

export const ForumSingleComments = (props: Props) => {
  const classes = useStyles();

  const comments = props.comments || [];

  if (!comments || !Array.isArray(comments) || comments.length === 0)
    return null;

  return (
    <div className={classes.comments}>
      <ul>
        {comments.map((x, i) =>
          !x ? null : (
            <Comment
              queryDocument={GetForumBySlugDocument}
              key={`${x}-${i}`}
              comment={x}
            />
          )
        )}
      </ul>
    </div>
  );
};
